import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import getParameterByName from '../../util/url';

const useRedirectParams = (): void => {
    useEffect(() => {
        // todo: find way to attach this to guided session
        if (getParameterByName('redirect') === 'guided') {
            datadogRum.addError('Validation Redirect');
        }
    }, []);
};

export default useRedirectParams;
